import { Button } from '@progress/kendo-react-buttons';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import { FormInput } from 'commons/forms/form';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { logout } from '../../redux/slices/appStateSlice';

export default function Account() {
  const user = useAppSelector(state => state.appState.user);
  const dispatch = useDispatch();
  return (
    <Card type="none" canCollapse={false}>
      <Header title="Compte" />
      <Body>
        <Form
          initialValues={{
            user: user
          }}
          render={() => (
            <FormElement style={{ width: '300px' }}>
              <fieldset className={'k-form-fieldset'}>
                <Field
                  disabled
                  value={user}
                  id={'user'}
                  name={'user'}
                  label={'Utilisateur'}
                  component={FormInput}
                />
                <div className="k-form-buttons">
                  <Button icon={'logout'} onClick={() => dispatch(logout())}>
                    Déconnecter
                  </Button>
                </div>
              </fieldset>
            </FormElement>
          )}
        />
      </Body>
    </Card>
  );
}
